export default "__VITE_ASSET__2roYgu6O__"